//FUNCIONS
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../store/createStore';
import { methodSelectedRequest } from '../../../store/modules/parameter/actions';

//HOOKS
import { useCheckoutInfo } from '../../../hooks/useCheckoutInfo';
import { useTranslation } from '../../../hooks/useTranslation';

//TYPES

//COMPONENTS
import AccountPayment from '../../../components/AccountPayment';

//STYLES
import {
  Container,
  ContainerPayments,
  ContainerDefaultPayCard,
  CardNumber,
  CardName,
  ContainerPaymentRight,
  ContainerPaymentData,
  ContainerDataRequest,
  ContainerDataRequestItem,
  ContainerPaymentLeft
} from './styles';
import { config } from '../../../config';
import PaymentList from './components/PaymentList';
import { RoundHelper } from '../../../utils/roundHelper';

const ViewPayment: React.FC = () => {
  const { onTranslation: t } = useTranslation();

  const dispatch = useDispatch();
  const { methods, method, payOnDelivery } = useSelector((state: StoreState) => state.parameter);
  const { checkout, methodPaymentSelected, shipping } = useSelector((state: StoreState) => state.checkout);
  const { onsetMethodSelect, methodSelected, addressSelected } = useCheckoutInfo();

  const handledSetMethodSelect = useCallback((methodId: number, methodTypeId: number) => {
    dispatch(methodSelectedRequest(methodTypeId, methodId));
    onsetMethodSelect({ id: methodId, type: methodTypeId });
  }, [dispatch, onsetMethodSelect]);

  useEffect(() => {
    if (methods && !methodSelected.id && !config.isNewLayoutChosePayment)
      methods.map(method => {
        if (method.selected === 1 && method.id) {
          handledSetMethodSelect(method.id, 0);
        }
        return method;
      });
  }, [methods, methodSelected, handledSetMethodSelect]);

  return (
    <>
      <Container>
        <ContainerPayments>
          <ContainerPaymentLeft>
            {
              config.isNewLayoutChosePayment ? (<PaymentList />)
                : (
                  <AccountPayment handledSetMethodSelectExt={handledSetMethodSelect} isCheckout={true} />
                )
            }
          </ContainerPaymentLeft>

          <ContainerPaymentRight>

            <ContainerPaymentData>
              <ContainerDataRequest>
                <ContainerDataRequestItem>
                  <h4>{t('main.new_checkout.view_payment.order_summary')}</h4>
                </ContainerDataRequestItem>
                <ContainerDataRequestItem>
                  <span>{t('main.new_checkout.view_payment.subtotal')}</span>
                  <span>{RoundHelper.toFormatted(checkout.sub_total)}</span>
                </ContainerDataRequestItem>
                <ContainerDataRequestItem>
                  <span>{t('main.new_checkout.view_payment.shipping')}</span>
                  <span>{shipping && shipping > 0 ? RoundHelper.toFormatted(shipping) : 'Grátis'}</span>
                </ContainerDataRequestItem>
                {
                  Number(checkout.discount) > 0 && (
                    <ContainerDataRequestItem>
                      <span>{t('main.new_checkout.view_payment.discount')}</span>
                      <span>{RoundHelper.toFormatted(checkout.discount)}</span>
                    </ContainerDataRequestItem>
                  )
                }
                <ContainerDataRequestItem>
                  <span>{t('main.new_checkout.view_payment.total')}</span>
                  <span>{RoundHelper.toFormatted(RoundHelper.toNumber(checkout.grand_total) + shipping)}
                  </span>
                </ContainerDataRequestItem>
              </ContainerDataRequest>
            </ContainerPaymentData>
            {
              !config.isNewLayoutChosePayment && (
                <>
                  {
                    payOnDelivery ? (
                      <>
                        <ContainerPaymentData>
                          <ContainerDataRequest>

                            <ContainerDataRequestItem>
                              <h4>{t('main.new_checkout.view_payment.method_selected')}</h4>
                            </ContainerDataRequestItem>
                            <ContainerDataRequestItem>
                              <ContainerDefaultPayCard>
                                <CardNumber>
                                  <h3>{t('main.component_account_payment.pay_on_delivery')}</h3>
                                </CardNumber>
                              </ContainerDefaultPayCard>
                            </ContainerDataRequestItem>
                          </ContainerDataRequest>
                        </ContainerPaymentData>
                      </>
                    ) : (
                      <>
                        {method && (
                          <ContainerPaymentData>
                            <ContainerDataRequest>

                              <ContainerDataRequestItem>
                                <h4>{t('main.new_checkout.view_payment.method_selected')}</h4>
                              </ContainerDataRequestItem>

                              <ContainerDataRequestItem>
                                <ContainerDefaultPayCard>
                                  <CardNumber>
                                    {/* {method.card_brand === 'visa' && <FaCcVisa size={23} />}
                            {method.card_brand === 'mastercard' && <FaCcMastercard size={23} />}
                            {method.card_brand === 'amex' && <FaCcAmex size={23} />}
                            {method.card_brand === 'discover' && <FaCcDiscover size={23} />}
                            {method.card_brand === '' && <FaCreditCard size={23} />} */}
                                    <span>{'****.****.****.' + method.card_last_four}</span>
                                  </CardNumber>
                                  <CardName><span>{method.full_name}</span></CardName>
                                </ContainerDefaultPayCard>

                              </ContainerDataRequestItem>


                              {/* <ContainerDataRequestItem>
                    {method && (
                      <CardContainerSplit>
                        <CardSplit>
                          <Select
                            placeholder="Selecione a parcela"
                            noOptionsMessage={() => 'Nenhuma parcela disponivel! :('}
                            options={methodSplit}
                            onChange={(e) => handleadSelMethodSplit(e)}
                          />
                        </CardSplit>
                      </CardContainerSplit>
                    )}

                  </ContainerDataRequestItem> */}
                            </ContainerDataRequest>

                          </ContainerPaymentData>
                        )}
                      </>
                    )}</>)
            }
            {
              (methodPaymentSelected.cards.length > 0 ||
                methodPaymentSelected.cashOnDelivery.length > 0 ||
                methodPaymentSelected.others.length > 0) &&
              (

                <ContainerPaymentData>
                  <ContainerDataRequest>

                    <ContainerDataRequestItem>
                      <h4>{t('main.new_checkout.view_payment.method_selected')}</h4>
                    </ContainerDataRequestItem>

                    <ContainerDataRequestItem>
                      <ContainerDefaultPayCard>
                        {
                          methodPaymentSelected.cards.length > 0 && (
                            <>
                              <CardNumber>
                                <span>{'****.****.****.' + methodPaymentSelected.cards[0].card_last_four}</span>
                              </CardNumber>
                              <CardName><span>{methodPaymentSelected.cards[0].full_name}</span></CardName>
                            </>
                          )
                        }
                        {
                          methodPaymentSelected.others.length > 0 && (
                              <CardNumber>
                                <span>{methodPaymentSelected.others[0].name}</span>
                              </CardNumber>
                          )
                        }
                        {
                          methodPaymentSelected.cashOnDelivery.length > 0 && (
                              <CardNumber>
                                {
                                    addressSelected.type === "addressUser" ? (
                                      <>
                                        <span>{'Pagamento na entrega: ' + methodPaymentSelected.cashOnDelivery[0].name}</span>
                                      </>
                                    ) : (
                                      <span>{'Pagamento na retirada: ' + methodPaymentSelected.cashOnDelivery[0].name}</span>
                                    )
                                }
                              </CardNumber>
                          )
                        }
                      </ContainerDefaultPayCard>

                    </ContainerDataRequestItem>
                  </ContainerDataRequest>
                </ContainerPaymentData>
              )

            }

          </ContainerPaymentRight>
        </ContainerPayments>

      </Container >
    </>
  );
}

export default ViewPayment;
